import FetchFactory from '../factory';
import type { HalebopRequestErrorData } from '../factory';

const CONTROLLER_PATH = '/api-electra/Porting/';
const DEV_CONTROLLER_PATH = '/api-electra/Development/';

export type SendPortingCodeErrorData = HalebopRequestErrorData & {
  owner_address_not_found?: boolean;
};

class PortingModule extends FetchFactory<unknown> {
  async sendPortingCode(
    shoppingCartItemId: number,
    phoneNumber: string,
    parentMsisdn?: string,
    ownerSsn?: string,
  ) {
    const url = `${CONTROLLER_PATH}SendPortingCode`;
    return await this.call('POST', url, {
      ShoppingCartItemId: shoppingCartItemId,
      PhoneNumber: phoneNumber,
      ParentMsisdn: parentMsisdn || '',
      OwnerSocialSecurityNumber: ownerSsn || null,
    });
  }

  async devGetPortingCode(phoneNumber: string) {
    const RESOURCE = `${DEV_CONTROLLER_PATH}DevGetPortingCode`;
    return await this.call('POST', `${RESOURCE}`, {
      PhoneNumber: phoneNumber,
    });
  }

  async validatePortingCode(portingCode: string, phoneNumber: string) {
    const url = `${CONTROLLER_PATH}ValidatePortingCode`;
    return await this.call('POST', url, {
      PortingCode: portingCode,
      PhoneNumber: phoneNumber,
    });
  }
}

export default PortingModule;
